import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex-1 tw color-unset lineheight-unset py-2 px-6"
};
const _hoisted_2 = {
  class: "flex flex-col h-fit print:h-full bg-white pb-16"
};
const _hoisted_3 = {
  class: "w-full"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_billing_distribution = _resolveComponent("billing-distribution");
  const _component_distribution_detail = _resolveComponent("distribution-detail");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [$setup.section.selectedSectionToggle === 'Distribution' ? (_openBlock(), _createBlock(_component_billing_distribution, {
    key: 0,
    modalService: $props.modalService,
    accountingService: $props.accountingService,
    userService: $props.userService
  }, null, 8, ["modalService", "accountingService", "userService"])) : _createCommentVNode("", true), $setup.section.selectedSectionToggle === 'Details' ? (_openBlock(), _createBlock(_component_distribution_detail, {
    key: 1,
    accountingService: $props.accountingService,
    userService: $props.userService,
    modalService: $props.modalService
  }, null, 8, ["accountingService", "userService", "modalService"])) : _createCommentVNode("", true)])])]);
}